import LyCombination from './src/index.vue'

LyCombination.install = function (Vue) {
    Vue.component(LyCombination.name, LyCombination)
}

export default LyCombination



//////////////////
// WEBPACK FOOTER
// ../projectCore/src/components/combination/index.js
// module id = null
// module chunks = 